import { createFileRoute } from '@tanstack/react-router';
import { lerBusca, UsuariosPage } from '@/components/usuarios';

export const Route = createFileRoute('/_app/configuracoes/usuarios')({
  validateSearch: (bruto: Record<string, unknown>) => lerBusca(bruto),
  component: UsuariosRota,
});

function UsuariosRota() {
  return <UsuariosPage busca={Route.useSearch()} />;
}
